<template>
  <div class="series-pack-list">
    <template v-if="loading">
      <SeriesPackListItemSkeleton
        v-for="number in 3"
        :key="number"
        :style="skeletonStyles"
      />
    </template>
    <template v-if="!loading">
      <SeriesPackListItem
        v-for="pack in series.packs"
        :key="pack.id"
        :pack="pack"
        :current="current"
      />
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import SeriesPackListItem from '@/series/components/series-pack-list-item';
import SeriesPackListItemSkeleton from '@/series/components/series-pack-list-item-skeleton';

export default defineComponent({
  name: 'SeriesPackList',

  /**
   * 属性
   */
  props: {
    series: Object,
    loading: Boolean,
    skeletonBackground: String,
  },

  /**
   * 数据
   */
  data() {
    return {
      postCache: null,
    };
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      post: 'post/show/post',
      currentPosition: 'series/sideSheet/currentPosition',
    }),

    current() {
      if (!this.postCache) return;

      return {
        packId: this.postCache.pack.id,
        nodeId: this.postCache.id,
      };
    },

    skeletonStyles() {
      let styles = {};

      if (this.skeletonBackground) {
        styles = {
          '--skeleton-background': `${this.skeletonBackground}`,
        };
      }

      return styles;
    },
  },

  watch: {
    post(newValue, oldValue) {
      if (newValue) {
        this.postCache = newValue;
      }

      if (!this.postCache && oldValue) {
        this.postCache = oldValue;
      }
    },

    currentPosition(newValue, oldValue) {
      if (newValue) {
        this.scrollToCurrentPosition(newValue);
      }

      if (newValue === null && oldValue) {
        this.scrollToCurrentPosition(oldValue);
      }
    },
  },

  /**
   * 已挂载
   */
  mounted() {
    if (this.currentPosition) {
      this.scrollToCurrentPosition(this.currentPosition);
    }
  },

  /**
   * 取消挂载
   */
  unmounted() {
    if (this.currentPosition) {
      this.setCurrentPosition('');
    }
  },

  /**
   * 已创建
   */
  created() {
    if (!this.postCache && this.post) {
      this.postCache = this.post;
    }
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setCurrentPosition: 'series/sideSheet/setCurrentPosition',
    }),

    scrollToCurrentPosition(currentPosition) {
      // 滚动页面侧板
      const pageSideSheetElement = document.querySelector('.page-side-sheet');

      // 重置
      pageSideSheetElement.scrollTo({
        top: 0,
      });

      // page side sheet 距离窗口顶部 90px
      const pageSideSheetTop = 90;

      // 偏移量
      const offset = 40;

      // 当前位置元素
      const currentElement = document.getElementById(currentPosition);

      if (currentElement) {
        // 当前位置
        const position =
          currentElement.getBoundingClientRect().top -
          pageSideSheetTop -
          offset;

        // const { scrollTop, scrollHeight, clientHeight } = pageSideSheetElement;
        // 滚动到当前位置
        pageSideSheetElement.scrollTo({
          top: position,
        });
      }
    },
  },

  /**
   * 使用组件
   */
  components: {
    SeriesPackListItem,
    SeriesPackListItemSkeleton,
  },
});
</script>

<style scoped>
@import './styles/series-pack-list.css';
</style>
